import axios from "axios";

// Pruebas corre en *.multytest.com o *.sslip.io; cualquier otro dominio es producción.
const IS_TEST = /(multytest\.com|sslip\.io)$/.test(window.location.hostname);

export const API_BASE_URL = IS_TEST
  ? "https://server.multytest.com"
  : "https://api.multyhealth.com";
// export const API_BASE_URL = "http://localhost:8000";

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});